export const UMB_EXTENSION_COLLECTION_ALIAS = 'Umb.Collection.Extension';
